import { Component, OnInit, OnDestroy } from '@angular/core';
import { forkJoin, of, Subject } from 'rxjs';
import { first, switchMap, takeUntil } from 'rxjs';
import { CartRow, CartService, Product, ProductService } from 'gung-standard';

@Component({
  selector: 'tylo-preliminary-delivery-time-warning',
  templateUrl: './tylo-preliminary-delivery-time-warning.component.html',
  styleUrls: ['./tylo-preliminary-delivery-time-warning.component.css']
})
export class TyloPreliminaryDeliveryTimeWarningComponent implements OnInit, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();

  show = false;

  constructor(private productService: ProductService, private cartService: CartService) {}

  ngOnInit() {
    this.cartService
      .getCurrentCart()
      .pipe(
        takeUntil(this.unsubscribe),
        switchMap(cartRows =>
          forkJoin({
            cartRows: of(cartRows),
            products: this.productService.getFullProductsByIds(cartRows.map(cr => cr.productId)).pipe(first())
          })
        )
      )
      .subscribe(({ cartRows, products }) => {
        this.show = false;

        // If a cart contains more than 20 units from ar.artkat=1  (Electical Heaters) display warning at checkout
        // OR
        // If a cart contains more than 10 units from ar.artkat=2  (Steam generators) display warning at checkout
        this.setWarningMessage('1', 20, products, cartRows);
        this.setWarningMessage('2', 10, products, cartRows);
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private setWarningMessage(artkat: string, maxQty: number, products: Product[], cartRows: CartRow[]): void {
    // get all products ar.artkat
    const productsArtkat = products.filter(product => product.extra.ar.artkat === artkat).map(product => product.id);
    if (productsArtkat.length > 0) {
      // get all cart row of this products and get total quantity
      const cartRowsArtkat = cartRows.filter(cartRow => productsArtkat.includes(cartRow.productId));

      const cartRowsArtkatQty = cartRowsArtkat.map(cartRow => cartRow.qty).reduce((a, b) => a + b, 0);
      if (cartRowsArtkatQty > maxQty) {
        this.show = true;
      }
    }
  }
}
